//@flow
import * as React from 'react';
import { connect } from 'react-redux';
import * as actions from '../../redux/kratos/actions';
import type { SubmittedForm$Props } from './flowTypes'

class SubmittedForm extends React.Component<SubmittedForm$Props> {
    componentWillUpdate(){
        const { kratos } = this.props;
    
        if (kratos.invoiceSubmitted) {
            this.props.formDataSubmissionCompleted();
        }
    }

    render(){
        return (
            <div className="container">
                <div className="row">
                    <br />
                </div>
                <div className="row">
                    <h3>Invoice Data Extraction</h3>
                </div>
                <div className="row">
                    <div className="alert alert-success" role="alert">
                         Your task has been submitted successfully.
                    </div>
                </div>    
            </div>
        )
    }
    
}

const mapStateToProps:any = (state, ownProps) => {
    return {
        kratos: state.kratos
    }
}

const mapDispatchToProps:any = (dispatch, ownProps) => {
    return {
      formDataSubmissionCompleted: () => {
         dispatch(actions.formDataSubmissionCompleted())  
      }
    }
}

export default connect(mapStateToProps,mapDispatchToProps)(SubmittedForm);


// WEBPACK FOOTER //
// ./src/views/ProjectKratos/SubmittedForm.js